/*******************************************************************
* PAGE        : StripeCheckoutForm 
* REMARKS     :
* CREATED ON  : 02-09-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 02-09-2026
********************************************************************/

import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import React, { useState } from 'react';

// #region Component
const StripeCheckoutForm = ({ formData, ticketTotalPrice, currency, ticketIssueID, promoCodeId, onSuccess, onClose }) => {

    // #region States
    const stripe = useStripe();
    const elements = useElements();

    const [processing, setProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    // #endregion

    // #region Methods
    const handlePayment = async (event) => {

        event.preventDefault();

        if (!stripe || !elements) { return; }

        setProcessing(true);
        setErrorMessage("");

        const { error, paymentIntent } =
            await stripe.confirmPayment({
                elements,
                confirmParams: {
                    payment_method_data: {
                        billing_details: {
                            name: formData.name,
                            email: formData.email,
                            phone: formData.whatsapp,
                        },
                    },
                },
                redirect: "if_required",
            });

        if (error) {
            console.error("Stripe Payment Error:", error);
            setErrorMessage(error.message || "Payment failed. Please try again.");
            setProcessing(false);
            return;
        }

        if (paymentIntent) {
            console.log("Payment Intent:", paymentIntent);
            if (paymentIntent.status === "succeeded") {
                // Stripe payment successful
                onSuccess(paymentIntent.id);
            } else if (paymentIntent.status === "processing") {
                setErrorMessage("Your payment is being processed. Please wait.");
            } else {
                setErrorMessage("Payment was not completed.");
            }
        }
        setProcessing(false);
    };
    // #endregion

    return (
        <React.Fragment>
            <form onSubmit={handlePayment}>

                <PaymentElement />

                {errorMessage && (
                    <div style={{ color: "red", marginTop: 10 }}>
                        {errorMessage}
                    </div>
                )}

                <button type="submit" disabled={!stripe || !elements || processing}>
                    {processing ? "Processing..." : `Pay ${currency} ${ticketTotalPrice}`}
                </button>
            </form>
        </React.Fragment>
    );
};
// #endregion

export default StripeCheckoutForm;